export default __webpack_public_path__ + "static/media/home2.0972257a.png";